import BreadCrumb from "@/src/components/Shared/BreadCrumbs";

import { useIntl } from "react-intl";
import server from "@/src/api/server";
import Seo from "@/src/components/Shared/Next-seo";
import Blogs from "@/src/components/Home/Blogs";

import {
  checkRedirect,
  mapBlogForListing,
} from "@/src/components/helpers/functions";

const BlogsPage = ({ blogsData, seoData }) => {
  const { formatMessage, locale } = useIntl();
  return (
    <div>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
        />
      )}
      <BreadCrumb
        heading={formatMessage({ id: "blog" })}
        description={`${formatMessage({
          id: "main",
        })} / ${formatMessage({
          id: "blog",
        })}`}
        background={blogsData?.breadCurmbImage}
      />

      <div className="row">
        <div className="info"></div>
      </div>
      <Blogs blogs={blogsData?.items} />
    </div>
  );
};

export async function getServerSideProps(ctx) {
  const [homeResponse, blogs, seoPageResponse] = await Promise.all([
    server.get("/pages/home"),
    server.get("/blogs"),
    server.get("/pages/seo-data"),
    
  ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];

  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "blogs"
  );
  //   const socialsResponse = await server.get("/settings/socials");

  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  return {
    props: {
      //   socialsData: socialsResponse?.data?.data?.socials || [],
      blogsData: {
        ...homeData("intro"),
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
        items: (blogs?.data?.data?.blogs || []).map((blog) =>
          mapBlogForListing(blog)
        ),
      },
      seoData,
    },
  };
}

export default BlogsPage;
